import { render } from "./SurveyEndPage.vue?vue&type=template&id=78c0e67c"
import script from "./SurveyEndPage.vue?vue&type=script&lang=js"
export * from "./SurveyEndPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__